import ActionTypeItem from "../ActionTypeItem";

export default class GuardarItem extends ActionTypeItem {
    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.procesandoComando = true;
        // nuevoEstado.flag.sensorDeAccionGuardar = !(estado.flag.sensorDeAccionGuardar);
        // nuevoEstado.flag.sensorDeAccionGuardar = this.payload;
        return nuevoEstado;
    }
}
